var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "padding" },
    [
      _c(
        "div",
        { staticClass: "level m-10" },
        [
          _c(
            "b-field",
            { staticClass: "level-left" },
            [
              _c(
                "b-select",
                {
                  attrs: { placeholder: "Select a region", rounded: "" },
                  model: {
                    value: _vm.selectedRegion,
                    callback: function ($$v) {
                      _vm.selectedRegion = $$v
                    },
                    expression: "selectedRegion",
                  },
                },
                [
                  _c("option", { attrs: { value: "CN" } }, [_vm._v(" China ")]),
                  _c("option", { attrs: { value: "notCN" } }, [
                    _vm._v(" Rest of world "),
                  ]),
                  _c("option", { attrs: { value: "all" } }, [
                    _vm._v(" All countries "),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "buttons level-right" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    rounded: "",
                    type: "is-info",
                    "icon-left": "folder",
                  },
                  on: {
                    click: function ($event) {
                      _vm.isEditingTemplate = true
                    },
                  },
                },
                [_vm._v(" Manage template ")]
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    rounded: "",
                    "icon-left": "flag",
                    type: _vm.isFlagView ? "is-danger" : "",
                  },
                  on: {
                    click: function ($event) {
                      _vm.isFlagView = !_vm.isFlagView
                    },
                  },
                },
                [_vm._v(" View alerts ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { rounded: "", "icon-left": "rotate" },
                  on: { click: _vm.refresh },
                },
                [_vm._v(" Refresh ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { rounded: "", "icon-left": "filter" },
                  on: { click: _vm.clearFilter },
                },
                [_vm._v(" Clear Filter ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-loading", {
        attrs: { "is-full-page": false },
        model: {
          value: _vm.isLoading,
          callback: function ($$v) {
            _vm.isLoading = $$v
          },
          expression: "isLoading",
        },
      }),
      _c("ag-grid-vue", {
        staticClass: "ag-theme-alpine",
        staticStyle: { width: "100%", height: "700px", "z-index": "1" },
        attrs: {
          modules: _vm.modules,
          "row-data": _vm.data,
          "get-row-style": _vm.getRowStyle,
          "grid-options": _vm.gridOptions,
          pagination: true,
          "pagination-auto-page-size": true,
          "get-context-menu-items": _vm.getContextMenuItems,
          "overlay-no-rows-template": _vm.overlayNoRowsTemplate,
        },
        on: { "grid-ready": _vm.gridReady },
      }),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditingTemplate,
            "has-modal-card": "",
            "trap-focus": "",
            scroll: "keep",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingTemplate = $event
            },
          },
        },
        [_c("TemplateModal", { on: { "on-close": _vm.close } })],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditingSetting,
            "has-modal-card": "",
            "trap-focus": "",
            scroll: "keep",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingSetting = $event
            },
          },
        },
        [
          _c("ReminderSettingModal", {
            attrs: { distributor: _vm.selectedDi },
            on: { "on-close": _vm.close },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditingCurSetting,
            "has-modal-card": "",
            "trap-focus": "",
            scroll: "keep",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingCurSetting = $event
            },
          },
        },
        [
          _c("ReminderSettingModal", {
            attrs: { distributor: _vm.selectedDi, "cur-config": _vm.curConfig },
            on: { "on-close": _vm.close },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isShowingHistory,
            "has-modal-card": "",
            "trap-focus": "",
            scroll: "keep",
          },
          on: {
            "update:active": function ($event) {
              _vm.isShowingHistory = $event
            },
          },
        },
        [
          _c("HistoryModal", {
            attrs: { distributor: _vm.selectedDi },
            on: { "on-close": _vm.close },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditingDistributorSetting,
            "has-modal-card": "",
            "trap-focus": "",
            scroll: "keep",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingDistributorSetting = $event
            },
          },
        },
        [
          _c("DistributorSettingModal", {
            attrs: { distributor: _vm.selectedDi },
            on: { "on-close": _vm.close },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isUploadFileModalOpen,
            "has-modal-card": "",
            "trap-focus": "",
            scroll: "keep",
          },
          on: {
            "update:active": function ($event) {
              _vm.isUploadFileModalOpen = $event
            },
          },
        },
        [
          _c("UploadModal", {
            attrs: { distributor: _vm.selectedDi },
            on: { "on-close": _vm.close },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isLegalModalOpen,
            "has-modal-card": "",
            "trap-focus": "",
            scroll: "keep",
          },
          on: {
            "update:active": function ($event) {
              _vm.isLegalModalOpen = $event
            },
          },
        },
        [
          _c("LegalModal", {
            attrs: { distributor: _vm.selectedDi },
            on: { "on-close": _vm.close },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isAiEmailModalOpen,
            "has-modal-card": "",
            "trap-focus": "",
            scroll: "keep",
          },
          on: {
            "update:active": function ($event) {
              _vm.isAiEmailModalOpen = $event
            },
          },
        },
        [
          _c("AiEmailModal", {
            attrs: { distributor: _vm.selectedDi },
            on: { "on-close": _vm.close },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }